import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import {
  LOAD_RESETPASSWORD,
  CHANGE_RESETPASSWORD,
  DELETE_RESETPASSWORD,
} from './constants';

import {
  loadResetPasswordError,
  loadResetPasswordSuccess,
  changeResetPasswordError,
  changeResetPasswordSuccess,
  deleteResetPasswordSuccess,
  deleteResetPasswordError,
} from './actions';

import {
  selectResetPasswordDomain,
  selectResetPasswordData,
} from './selectors';

import { Button, notification, Divider, Space } from 'antd';

export function* loadResetPassword() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the resetPassword
    const resetPasswordList = yield requestWrapper(
      'GET',
      `resetPassword/`,
      '',
      currentUser?.token,
    );

    if (!resetPasswordList) {
      yield put(loadResetPasswordSuccess(false));
    } else {
      yield put(loadResetPasswordSuccess(resetPasswordList));
    }
  } catch (error) {
    yield put(loadResetPasswordError(error));
  }
}

export function* changeResetPassword(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    
    //const resetPasswordData = yield select(selectResetPasswordData());
    const { resetPasswordData } = action;

    let changedResetPassword = false,
      isNew = !resetPasswordData.hasOwnProperty('_id');

    if (resetPasswordData._id === undefined) {
      changedResetPassword = yield requestWrapper(
        'POST',
        'resetPassword/new/',
        resetPasswordData,
      );
      notification.success({ message: 'Created' });
    } else {
      changedResetPassword = yield requestWrapper(
        'PATCH',
        'resetPassword/',
        resetPasswordData,
      );
      notification.success({ message: 'Updated' });
    }

    if (!changedResetPassword) {
      yield put(changeResetPasswordSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/resetPassword/`+resetPasswordData._id });
      }
      yield put(changeResetPasswordSuccess(changedResetPassword));
    }
  } catch (error) {
    yield put(changeResetPasswordError(error));
  }
}

export function* deleteResetPassword(action) {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');
    const { id } = action;

    const deleteResetPassword = yield requestWrapper(
      'PATCH',
      `resetPassword/remove`,
      {
        _id: id,
        active: false,
      },
      token,
    );

    if (deleteResetPassword) {
      yield put(deleteResetPasswordSuccess());
    }
  } catch (error) {
    yield put(deleteResetPasswordError(error));
  }
}

export default function* resetPasswordSaga() {
  yield takeLatest(LOAD_RESETPASSWORD, loadResetPassword);
  yield takeLatest(CHANGE_RESETPASSWORD, changeResetPassword);
  yield takeLatest(DELETE_RESETPASSWORD, deleteResetPassword);
}
